export default {
  zh: {
    general: {
      newTitle: '添加视图',
      existTitle: '编辑视图',
    },
    viewName: {
      stepName: '输入视图名称',
      inputs: {
        viewName: '视图名称',
      },
    },
    criteria: {
      stepName: '设置筛选条件',
      columns: {
        field: '字段',
        condition: '条件',
        value: '字段值',
      },
      buttons: {
        newFilter: '新筛选条件',
      },
      inputs: {
        condition: '筛选条件间的关系',
      },
    },
    selectors: {
      stepName: '设置显示字段',
      sectionTitles: {
        available: '可选字段',
        selected: '已选字段',
      },
    },
    visibility: {
      stepName: '设置分享',
      buttons: {
        addUserToShare: '分享给其他用户',
        addUserOrTeamToShare: '分享给其他用户或群组',
      },
      treeHelpText: '单击可选择组并显示相应用户在右侧，双击将该群组或者用户加入视图的分享',
      defaultTitle: '从结构树中选择群组',
      modal: {
        searchInput: '用户搜索'
      },
    },
  },
  en: {
    general: {
      newTitle: 'Add New View',
      existTitle: 'Edit View',
    },
    viewName: {
      stepName: 'Enter View Name',
      inputs: {
        viewName: 'View Name',
      },
    },
    criteria: {
      stepName: 'Specify Filter Criteria',
      columns: {
        field: 'Field',
        condition: 'Condition',
        value: 'Value',
      },
      buttons: {
        newFilter: 'New Filter',
      },
      inputs: {
        condition: 'Condition Logic',
      },
    },
    selectors: {
      stepName: 'Select Fields to Display',
      sectionTitles: {
        available: 'Available Fields',
        selected: 'Selected Fields',
      },
    },
    visibility: {
      stepName: 'Restrict Visibility',
      buttons: {
        addUserToShare: 'Add User to Share',
        addUserOrTeamToShare: 'Add User or Team to Share',
      },
      treeHelpText: 'Click on a team name to show team members on the right section. Double click will select a specific user or team to share.',
      defaultTitle: 'Select a Team from Tree',
      modal: {
        searchInput: 'Search Users'
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/i18n.js